<template>
    <transition name="v">
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </transition>
</template>

<script>
    export default {
        data() {
            return {
            }
        }

    }

</script>


<style>
    body{
        overflow-y: scroll;
    }
    .v-enter,
    .v-leave-to {
        opacity: 0;
    }
    
    .v-enter-to,
    .v-leave {
        opacity: 1;
    }
    
    .v-leave-active,
    .v-enter-active {
        transition: .3s;
    }
    
    .v-enter-active {
        transition-delay: .301s;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue?6dc016d0